import script from "./SnapshotList.vue?vue&type=script&setup=true&lang=js"
export * from "./SnapshotList.vue?vue&type=script&setup=true&lang=js"

import "./SnapshotList.vue?vue&type=style&index=0&id=9a15c0e0&lang=scss&scoped=true"
import "./SnapshotList.vue?vue&type=style&index=1&id=9a15c0e0&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9a15c0e0"]])

export default __exports__